import { useState, useEffect, useRef, useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';
import { focusAfterPaint } from '@/utils/dom';

export interface AddVehicleModalProps {
  open: boolean;
  theme?: string;
  saving?: boolean;
  onSave: (data: { vehicleName: string }) => void;
  onCancel: () => void;
}

export function AddVehicleModal({
  open,
  theme,
  saving = false,
  onSave,
  onCancel,
}: AddVehicleModalProps) {
  const [vehicleName, setVehicleName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  // Reset form and focus input when modal opens
  useEffect(() => {
    if (open) {
      setVehicleName('');
      focusAfterPaint(inputRef);
    }
  }, [open]);

  const handleSave = useCallback(() => {
    if (!vehicleName || !vehicleName.trim()) {
      (window as any).App?.showPopupNotification?.('Assigned Vehicle Name required.', 'error');
      return;
    }

    onSave({ vehicleName: vehicleName.trim() });
  }, [vehicleName, onSave]);

  return (
    <BaseFormModal
      open={open}
      title="Add Assigned Vehicle"
      theme={theme}
      dialogClass="kstc-dialog--form"
      saveText={saving ? 'Saving...' : 'Add'}
      saveDisabled={saving}
      busy={saving}
      onSave={handleSave}
      onCancel={onCancel}
    >
      <div className="kstc-form-group">
        <label className="kstc-label">Assigned Vehicle Name</label>
        <input
          ref={inputRef}
          type="text"
          className="kstc-input kst-vehicle-name-input"
          value={vehicleName}
          onChange={(e) => setVehicleName(e.target.value)}
          placeholder="Enter vehicle name..."
        />
      </div>
    </BaseFormModal>
  );
}

(window as any).AddVehicleModalReact = AddVehicleModal;
